module.exports = __webpack_public_path__ + "static/marc-c5d43972dd56bd44f2080d665af237ea.png";